var _style, _circle, _defs, _defs2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _rect2, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99 100",
    style: {
      enableBackground: "new 0 0 99 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6765AD;}\r\n\t.st1{clip-path:url(#SVGID_2_);}\r\n\t.st2{clip-path:url(#SVGID_4_);fill:#D1D5D6;}\r\n\t.st3{clip-path:url(#SVGID_4_);fill:#C9C9C9;}\r\n\t.st4{clip-path:url(#SVGID_4_);fill:#F1F1F1;}\r\n\t.st5{clip-path:url(#SVGID_4_);fill:#FFA932;}\r\n\t.st6{clip-path:url(#SVGID_4_);fill:#FF9400;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 49.6,
    cy: 49.7,
    r: 47.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Reports_1_"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 15.3,
    y: 23.4,
    width: 66.2,
    height: 56.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 15.3,
    y: 23.4,
    width: 66.2,
    height: 56.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.3,35.7h-3.2h-8.9v-6.3c0-3.2,2.6-5.8,5.8-5.8c3.5,0,6.3,2.8,6.3,6.3V35.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.2,35.7h3.2V30c0-3.5-2.8-6.3-6.3-6.3C21,23.7,25.6,24.8,24.2,35.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27,35.7V30c0-3.5-2.8-6.3-6.3-6.3h43.7c3.5,0,6.3,2.8,6.3,6.3v5.8l-0.1,31.1v5.8c0,3.5,1.1,6.2,4.5,6.2 l-5.2,0.1H33.1c-3.5,0-6.3-2.8-6.3-6.3v-5.8L27,35.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M62.1,68.7H35.7c-1.5,0-2.8-1.3-2.8-2.8c0-1.5,1.3-2.8,2.8-2.8h26.4c1.5,0,2.8,1.3,2.8,2.8 C64.9,67.5,63.7,68.7,62.1,68.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M62.1,61.7H35.7c-1.5,0-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8h26.4c1.5,0,2.8,1.3,2.8,2.8S63.7,61.7,62.1,61.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M62.1,54.8H35.7c-1.5,0-2.8-1.3-2.8-2.8c0-1.5,1.3-2.8,2.8-2.8h26.4c1.5,0,2.8,1.3,2.8,2.8 C64.9,53.5,63.7,54.8,62.1,54.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.4,66.8v5.8c0,3.5-2.8,6.3-6.3,6.3H32.9c3.5,0,6.3-2.8,6.3-6.3v-5.8H81.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M63.4,36.7c-2.3,0-4.1,1.8-4.1,4.1c0,2.3,1.8,4.1,4.1,4.1c2.3,0,4.1-1.9,4.1-4.1 C67.5,38.5,65.7,36.7,63.4,36.7 M63.4,43.2c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4 C65.8,42.1,64.7,43.2,63.4,43.2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M34.5,31.1c-2.3,0-4.1,1.8-4.1,4.1c0,2.3,1.8,4.1,4.1,4.1s4.1-1.9,4.1-4.1C38.6,33,36.7,31.1,34.5,31.1  M34.5,37.6c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4s2.4,1.1,2.4,2.4C36.8,36.6,35.8,37.6,34.5,37.6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M48.9,36.7c-2.3,0-4.1,1.8-4.1,4.1c0,2.3,1.8,4.1,4.1,4.1c2.3,0,4.1-1.9,4.1-4.1 C53.1,38.5,51.2,36.7,48.9,36.7 M48.9,43.2c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4 C51.3,42.1,50.2,43.2,48.9,43.2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 40.8,
    className: "st6",
    width: 8.4,
    height: 1.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.6,
    y: 33.6,
    transform: "matrix(0.3369 -0.9416 0.9416 0.3369 -8.4637 64.2567)",
    className: "st6",
    width: 1.6,
    height: 9.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79.8,76.8c-1.1,1.2-2.8,2-4.6,2H32.9c1.8,0,3.5-0.8,4.6-2"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.458b307d633c9e125d7be79f10f2ba22.svg";
export { ForwardRef as ReactComponent };